import { api } from "..";

export interface DeleteOddsAdjustmentsParams {
  matchId: number;
  providerId: number;
  targetUsername?: string;
}

export interface DeleteOddsAdjustmentsResponse {
  success: boolean;
  deletedCount: number;
}

export async function deleteOddsAdjustments(
  params: DeleteOddsAdjustmentsParams
): Promise<DeleteOddsAdjustmentsResponse> {
  const res = await api.client.delete(
    `/sport-events-new/odds-adjustment/${params.matchId}`,
    {
      params: {
        providerId: params.providerId,
        targetUsername: params.targetUsername,
      },
    }
  );
  return res.data;
}
